import ScalarFormInputGroup_vue_vue_type_script_setup_true_lang_default from "./ScalarFormInputGroup.vue_vue_type_script_setup_true_lang.js";
//#region src/components/ScalarForm/ScalarFormInputGroup.vue
var ScalarFormInputGroup_default = ScalarFormInputGroup_vue_vue_type_script_setup_true_lang_default;
//#endregion
export { ScalarFormInputGroup_default as default };

//# sourceMappingURL=ScalarFormInputGroup.vue.js.map